import React from "react";

const GraySeparator = () => {
  return <div className="h-5 w-[1px] bg-gray-300 mx-3" />;
};

export default GraySeparator;
